"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.global-this.js";
import { TENANT_NAME } from '@autoguru/global-configs';
import { AsyncBoundary } from '@autoguru/suspense';
import { invariant } from '@autoguru/utilities';
import { createContext, useContext } from 'react';
import { useSelectedGlobalSupplier } from '../GlobalSupplierProvider';
import { useAccountSuppliersMeta } from './useAccountSuppliersMeta';
import { useResolvedSupplierId } from './useResolvedSupplierId';
import { jsx as _jsx } from "react/jsx-runtime";
const supplierContext = /*#__PURE__*/createContext(null);

/**
 * Ability to get the current wrapped supplier id and other generic information, like their name and dbId.
 */
export const useSupplierLegacy = () => {
  const contextValue = useContext(supplierContext);
  !(contextValue !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Please have a <SupplierProvider /> set in your tree') : invariant(false) : void 0;
  return contextValue;
};
const SupplierProviderLegacy = ({
  children,
  supplierId: retailSupplierId,
  routeSupplierId
}) => {
  const {
    isGroupViewer,
    resolvedSupplierId,
    isImpersonating,
    setViewerSupplierId,
    setRouteSupplierId
  } = useResolvedSupplierId({
    routeSupplierId,
    retailSupplierId
  });
  return resolvedSupplierId ? /*#__PURE__*/_jsx(ProviderWithSupplier, {
    isImpersonating: isImpersonating,
    retailSupplierId: retailSupplierId,
    supplierId: resolvedSupplierId,
    isGroupViewer: isGroupViewer,
    resolvedSupplierId: resolvedSupplierId,
    setRouteSupplierId: setRouteSupplierId,
    setViewerSupplierId: setViewerSupplierId,
    children: children
  }) : /*#__PURE__*/_jsx(ProviderWithoutSupplier, {
    isImpersonating: isImpersonating,
    retailSupplierId: retailSupplierId,
    isGroupViewer: isGroupViewer,
    resolvedSupplierId: resolvedSupplierId,
    setRouteSupplierId: setRouteSupplierId,
    setViewerSupplierId: setViewerSupplierId,
    children: children
  });
};
const ProviderWithSupplier = ({
  children,
  supplierId,
  retailSupplierId,
  setViewerSupplierId,
  setRouteSupplierId,
  isGroupViewer,
  isImpersonating
}) => {
  const {
    viewerSupplierMeta
  } = useAccountSuppliersMeta({
    supplierId
  });
  return /*#__PURE__*/_jsx(supplierContext.Provider, {
    value: {
      isImpersonating,
      retailSupplierId,
      viewerSupplierId: viewerSupplierMeta === null || viewerSupplierMeta === void 0 ? void 0 : viewerSupplierMeta.dbId.toString(),
      setViewerSupplierId,
      supplierName: (viewerSupplierMeta === null || viewerSupplierMeta === void 0 ? void 0 : viewerSupplierMeta.name) || null,
      isGroupViewer,
      setRouteSupplierId
    },
    children: children
  });
};
const ProviderWithoutSupplier = ({
  children,
  retailSupplierId,
  setViewerSupplierId,
  setRouteSupplierId,
  isGroupViewer,
  isImpersonating
}) => {
  return /*#__PURE__*/_jsx(supplierContext.Provider, {
    value: {
      retailSupplierId,
      viewerSupplierId: null,
      setViewerSupplierId,
      supplierName: null,
      isGroupViewer,
      isImpersonating,
      setRouteSupplierId
    },
    children: children
  });
};
export const SessionConnectedSupplierProviderLegacy = ({
  children,
  routeSupplierId
}) => {
  var _getSupplierId__unsta;
  const {
    id
  } = useSelectedGlobalSupplier();
  return /*#__PURE__*/_jsx(SupplierProviderLegacy, {
    routeSupplierId: routeSupplierId,
    supplierId: ((_getSupplierId__unsta = getSupplierId__unstable()) === null || _getSupplierId__unsta === void 0 ? void 0 : _getSupplierId__unsta.toString()) || id,
    children: children
  });
};
const getSupplierId__unstable = () => {
  if (typeof globalThis.selectedAccountId_1KEn81382 !== 'undefined') {
    // @ts-ignore
    return Number.parseInt(window['selectedWorkshopId_1KEn81382'], 10);
  }
  if (process.env.NODE_ENV !== "production") {
    //the ID for nz is 278, and it is temporary until we have a better option
    return TENANT_NAME === 'nz' ? 278 : 3532;
  }
  return null;
};
const Provider = props => /*#__PURE__*/_jsx(AsyncBoundary, {
  children: /*#__PURE__*/_jsx(SessionConnectedSupplierProviderLegacy, _objectSpread({}, props))
});
export default Provider;